import {
  apiClient
} from "./chunk-HCVPNQUB.mjs";

// src/ops/lambdaFailuresApi.ts
import { LambdaFailureService } from "@maat/api-shared";
var LAMBDA_FAILURE_SERVICE_PATH = {
  [LambdaFailureService.Main]: "/main",
  [LambdaFailureService.Booking]: "/booking"
};
var base = (service) => `${LAMBDA_FAILURE_SERVICE_PATH[service]}/api/admin/lambda-failures`;
var lambdaFailuresApi = {
  getSummary: async (service) => apiClient.get(base(service)),
  getMessages: async (service, queue) => apiClient.get(
    `${base(service)}/${encodeURIComponent(queue)}/messages`
  ),
  /**
   * Re-invoke the function with the parked event, then drop the message.
   *
   * Per-message, never per-queue: re-invoking a Lambda is neither cheap nor
   * safely repeatable, and one of these functions has a failure path where a
   * blind replay destroys the only pointer to an orphaned identity document.
   */
  redrive: async (service, queue, messageId) => apiClient.post(
    `${base(service)}/${encodeURIComponent(queue)}/messages/${encodeURIComponent(messageId)}/redrive`,
    {}
  ),
  discard: async (service, queue, messageId) => apiClient.delete(
    `${base(service)}/${encodeURIComponent(queue)}/messages/${encodeURIComponent(messageId)}`
  )
};

export {
  lambdaFailuresApi
};
